import React from 'react';
import classNames from 'classnames';

import { Container } from 'components/shared';

import { APP_NAME } from 'constants/app.constant';
import { PAGE_CONTAINER_GUTTER_X } from 'constants/theme.constant';

const FooterContent = () => {
	return (
		<div className="flex flex-col md:flex-row items-center justify-between flex-auto w-full">
			<span className="mb-1 md:mb-0 md:mr-4 text-xs md:text-body">
				&copy; {`${new Date().getFullYear()}`}{' '}
				<span className="font-semibold">{`${APP_NAME}`}</span>. Derechos
				reservados.
			</span>
			<div className="text-xs">
				<a className="text-gray" href="/#" onClick={e => e.preventDefault()}>
					Términos y Condiciones
				</a>
				<span className="mx-2 text-muted"> | </span>
				<a className="text-gray" href="/#" onClick={e => e.preventDefault()}>
					Política de Privacidad
				</a>
			</div>
		</div>
	);
};

export default function Footer({ pageContainerType }) {
	return (
		<footer
			className={classNames(
				`footer flex flex-auto items-center h-16 ${PAGE_CONTAINER_GUTTER_X}`,
			)}>
			{pageContainerType === 'contained' ? (
				<Container>
					<FooterContent />
				</Container>
			) : (
				<FooterContent />
			)}
		</footer>
	);
}
